import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const SideBarContainer = styled.div<{ isActive: boolean }>(
  ({ theme, isActive }) => css`
    background: ${theme.WHITE};
    border-right: 1px solid ${theme.GREY_3};
    width: 0;
    height: 100%;
    padding-top: 18px;
    overflow: hidden;
    -webkit-transition: all 0.4s ease 0s;
    -moz-transition: all 0.4s ease 0s;
    -o-transition: all 0.4s ease 0s;
    transition: all 0.4s ease 0s;

    & > * {
      opacity: 0;
      -webkit-transition: all 0.4s ease 0s;
      -moz-transition: all 0.4s ease 0s;
      -o-transition: all 0.4s ease 0s;
      transition: all 0.4s ease 0s;
    }

    ${isActive &&
    css`
      width: 298px;
      overflow-y: auto;
      padding-bottom: 80px;
      & > * {
        opacity: 1;
      }
    `};

    /* hide scrollbar */
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none; /* for Chrome, Safari, and Opera */
    }
  `
);

export const FiltersMain = styled.div`
  border-bottom: 1px solid ${({ theme }): string => theme.GREY_3};
`;
